
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EditMissionSpeedDialog extends Vue {
  @Prop({ type: Number }) speed = 0;
  @Prop() show = false;
  speed_kph = 0;
  editFormValid = false;
  created() {
    this.speed_kph = this.speed;
  }
  confirmUpdate(val: any) {
    this.$emit('update:show', false);
    this.$emit('update:speed', val);
  }
  close() {
    this.$emit('update:show', false);
  }
}
